/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Colplan2Inputs */

const zh_adminsubs_colplan2 = /** @type {(inputs: Adminsubs_Colplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计划`)
};

const en_adminsubs_colplan2 = /** @type {(inputs: Adminsubs_Colplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const es_adminsubs_colplan2 = /** @type {(inputs: Adminsubs_Colplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Adminsubs_Colplan2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_colplan2 = /** @type {((inputs?: Adminsubs_Colplan2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Colplan2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_colplan2(inputs)
	if (locale === "en") return en_adminsubs_colplan2(inputs)
	return es_adminsubs_colplan2(inputs)
});
export { adminsubs_colplan2 as "adminSubs_colPlan" }